/**
 * create an object from array of objects
 * the new object will contain all the properties of objects in array
 */
export default function createObjectFromArrayOfObjects(objects: any[]): Record<any, any> {
    return objects.reduce((obj, field) => ({
        ...obj,
        ...field,
    }), {})
}